import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import '@/assets/style/index.scss'
import YmapPlugin from 'vue-yandex-maps'
import yandexMap from "../config/yandexMap";

Vue.use(YmapPlugin, yandexMap);
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
